<!--<template>-->
  <!--<div class="card-media component">-->
    <!--<img-->
      <!--:src='src'-->
      <!--:alt='alt'-->
    <!--&gt;-->
  <!--</div>-->
<!--</template>-->

<script>
  export default {
    functional: true,

    name: 'UiCardMedia',

    props: {
      alt: String,
      media: {
        type: [String, Object],
        default: ''
      },
      position: {
        type: String,
        default: 'center center'
      },
      transition: {
        type: String,
        default: 'fade-transition'
      },
    },

    render (h, {data, children, props}) {
      const staticClass = 'card-media';
      data.staticClass = data.staticClass ? `${data.staticClass}` : staticClass
      data.style = data.style || {}
      data.style['background-image'] = data.style['background-image'] || `url(${props.media})`
      data.style['background-position'] = data.style['background-position'] || `center center`
      data.style['background-size'] = data.style['background-size'] || `cover`

      return h('section', {
        ...data,
      }, children)
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/UiCardMedia.vue